import React, { useEffect, useImperativeHandle } from "react";
import { Block, ConfirmationAlert, ReactDataTable } from "../../../../../components/Component";
import { useState } from "react";
import { showErrorToast, showSuccessToast } from "../../../../../utils";
import AddWard from "./AddWard";
import { clientWardRemove, listWardAPI, wardTableColumns } from "./WardData";
import { UserPermissionType, isCheckToList } from "../../../../../services/permission/permission";
const WardList = React.forwardRef(({ hospitalId, isHomeCare, isOpenAddModel, onCloseModel, onWardListLoaded }, ref) => {
  const [ward, setWard] = useState([]);
  const [status, setStatus] = useState();
  const [modal, setModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  useEffect(() => {
    loadWard();
    return () => {
      setWard();
      setStatus();
      setModal();
      setSelectedItem();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    setModal(isOpenAddModel);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpenAddModel]);
  useEffect(() => {
    if (status) {
      loadWard();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);
  function onEdit(row) {
    setSelectedItem(row);
    setModal(true);
  }
  useImperativeHandle(ref, () => ({
    reloadWard: () => {
      loadWard();
    },
  }));
  function loadWard() {
    if (isCheckToList(UserPermissionType.ward)) {
      listWardAPI(
        {
          clientId: hospitalId,
        },
        (list, error) => {
          if (error === null) {
            setWard(list);
            onWardListLoaded(list?.length ?? 0);
          }
        },
      );
    }
  }
  function onRemove(row) {
    ConfirmationAlert("Removing Ward!", "Do you want to remove ward " + row?.name + "?", () => {
      // This code block will be executed when the user confirms the removal

      clientWardRemove(
        {
          wardId: row?.id,
        },
        (data, error) => {
          if (error === null) {
            showSuccessToast("Ward is removed successfully");
            // history.goBack();
            loadWard();
          } else {
            showErrorToast(error.message);
          }
        },
      );
    });
  }
  return (
    <React.Fragment>
      <Block>
        <ReactDataTable
          data={ward}
          columns={wardTableColumns(onEdit, onRemove)}
          isAllowed={isCheckToList(UserPermissionType.ward)}
        />
      </Block>
      <AddWard
        visible={modal}
        hospitalId={hospitalId}
        isHomeCare={isHomeCare}
        item={selectedItem}
        onClosed={() => {
          setModal(false);
          onCloseModel();
          setSelectedItem();
        }}
        onSaved={() => {
          loadWard();
        }}
      />
    </React.Fragment>
  );
});
export default WardList;
